import React from 'react';
import { Card, CardText, CardBody, CardTitle } from 'reactstrap';
import { fromJS } from 'immutable';
import SidebarPanel from './SidebarPanel';
import CheckLog from './CheckLog';

const _noAdvisories = 'There are no advisories for this file.';

export default class ChecksPanel extends React.PureComponent {
  static get noAdvisories() {
    return _noAdvisories;
  }

  getChecks() {
    return this.props.checks || [];
  }

  formattedChecks = () => (<div>
    {this.getChecks().map((check, index) => (<CheckLog
      color
      heading={check.category}
      title={check.title}
      notes={check.report}
      description={check.description}
      key={`check${index}`}
    />))}
  </div>)

  render() {
    return (<SidebarPanel
      title={`Checks for ${this.props.filename}`}
      dismiss={this.props.dismiss}
    >
      <p className="docs-filecheck">
        For more information on how to interpret Digital Hub File Alerts,{' '}
        <a
          href="/wfdw/docs/digital-hub/digital-hub-file-alerts.html"
          target="_blank"
        >
          click here
        </a>
        .
      </p>
      {this.getChecks().length === 0 ?
        <p className="checks-empty">{ChecksPanel.noAdvisories}</p> :
        this.formattedChecks()
      }
    </SidebarPanel>);
  }
}
